import React from 'react';

const Eyebrow = ({ children, style }) => (
  <div style={{
    fontFamily: 'var(--font-sans)', fontSize: 10, fontWeight: 600,
    letterSpacing: '0.14em', textTransform: 'uppercase',
    color: 'var(--fg-subtle)', ...style,
  }}>
    {children}
  </div>
);

export default Eyebrow;
